var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraughtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "draught-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eazle---App-views",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-products",
    transform: "translate(-48, -355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(24, 331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "draught-icon",
    transform: "translate(24, 24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "draft",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9204,2.69888 C17.1102667,2.46746667 17.394,2.33333333 17.6933333,2.33333333 L21.0666667,2.33333333 C21.366,2.33333333 21.6497333,2.46746667 21.8396,2.69888 C22.0296,2.93028 22.1058667,3.23462667 22.0474667,3.52825333 L21.4313333,6.62857333 C21.8033333,6.77430667 22.0666667,7.1364 22.0666667,7.56 C22.0666667,8.11228 21.6189333,8.56 21.0666667,8.56 L20.3733333,8.56 L20.3733333,11.0933333 L18.3733333,11.0933333 L18.3733333,8.56 L12.6266667,8.56 C10.3789467,8.56 8.56,10.3789467 8.56,12.6266667 L8.56,27.6666667 L16.0333333,27.6666667 C16.0073333,27.2132 15.9676,26.7648 15.9141333,26.3214667 L15.914,26.3198667 L15.2068,20.6221333 C15.1362667,20.0162667 15.0934667,19.3906667 15.0934667,18.7333333 C15.0934667,18.1674667 15.1217333,17.6117333 15.1790667,17.08 L15.3290667,15.674 C15.4090667,14.924 15.4990667,14.0804 15.5390667,13.7068 C15.5809333,13.3168133 15.8468,12.9872533 16.2192,12.864 C18.358,12.1559867 20.6701333,12.15732 22.8305333,12.8627333 C23.2048,12.9849333 23.4724,13.3153467 23.5144,13.7068 C23.5544,14.0804 23.6444,14.924 23.7244,15.674 L23.8744,17.0801333 L23.8745333,17.082 C23.9316,17.6241333 23.9601333,18.1657333 23.9601333,18.7333333 C23.9601333,19.3894667 23.9173333,20.0289333 23.8464,20.6249333 L23.8458667,20.6298667 L23.1396,26.3198667 L23.1393333,26.3214667 C23.0858667,26.7648 23.0461333,27.2132 23.0201333,27.6666667 L28.6666667,27.6666667 C29.2189333,27.6666667 29.6666667,28.1144 29.6666667,28.6666667 C29.6666667,29.2189333 29.2189333,29.6666667 28.6666667,29.6666667 L3.33333333,29.6666667 C2.78105333,29.6666667 2.33333333,29.2189333 2.33333333,28.6666667 C2.33333333,28.1144 2.78105333,27.6666667 3.33333333,27.6666667 L6.56,27.6666667 L6.56,12.6266667 C6.56,9.27438667 9.27438667,6.56 12.6266667,6.56 L17.3150667,6.56 L16.7125333,3.52825333 C16.6541333,3.23462667 16.7304,2.93028 16.9204,2.69888 Z M19.4058667,6.56 L19.8484,4.33333333 L18.9116,4.33333333 L19.3541333,6.56 L19.4058667,6.56 Z M21.0229333,27.56 C21.0513333,27.0621333 21.0949333,26.5688 21.154,26.0801333 L21.1544,26.0768 L21.8604,20.3884 L21.8606667,20.3861333 C21.9229333,19.8626667 21.9601333,19.3030667 21.9601333,18.7333333 C21.9601333,18.5201333 21.9556,18.312 21.9465333,18.1066667 L17.1068,18.1066667 C17.0978667,18.3118667 17.0934667,18.5212 17.0934667,18.7333333 C17.0934667,19.3013333 17.1304,19.8478667 17.1929333,20.3874667 L17.1933333,20.3912 L17.8996,26.0801333 C17.9585333,26.5688 18.0021333,27.0621333 18.0305333,27.56 L21.0229333,27.56 Z M17.2942667,16.1066667 L21.7592,16.1066667 L21.7357333,15.886 C21.6889333,15.4477333 21.6388,14.9777333 21.5972,14.5882667 C20.2274667,14.2486667 18.8077333,14.2488 17.4565333,14.5861333 C17.4149333,14.976 17.3646667,15.4469333 17.3177333,15.886 L17.2942667,16.1066667 Z",
    id: "Shape",
    fill: "#00414B",
    mask: "url(#mask-4)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraughtIcon);
export default __webpack_public_path__ + "static/media/draught-icon.18e151961c9d9a496b14576bfe50ee9d.svg";
export { ForwardRef as ReactComponent };